export enum ContentAreaLayout {
  FullWidth = 'FullWidth',
  Centered = 'Centered'
}
